export default {
    MOVED: 'moved',
    ADDED: 'added',
    REMOVED: 'removed'
}
